var moduleMap = {
	"./ReviewApp": function() {
		return Promise.all([__webpack_require__.e("vendors-node_modules_sentry_browser_cjs_index_js-node_modules_xto10x_core_lib_networkUtils_js-a108ed"), __webpack_require__.e("vendors-node_modules_peoplecues_commons_dist_index_js-node_modules_peoplecues_commons_dist_th-604019"), __webpack_require__.e("src_bootstrap_js-node_modules_moment-timezone_node_modules_moment_locale_sync_recursive_-node-2ac7d1")]).then(function() { return function() { return (__webpack_require__(/*! ./src/bootstrap.js */ "./src/bootstrap.js")); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var oldScope = __webpack_require__.S["default"];
	var name = "default"
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});